import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { gibddFilterFields } from "./fields";

const GIBDDFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => gibddFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};

export default GIBDDFilter;
